import { Badge } from "@chakra-ui/react";

const StatusBadge = ({ loan }: { loan: any }) => {
  return (
    <Badge fontWeight="600" bg={`${loan.status.color}15`} color={loan.status.color}>
      {loan.status.label}
    </Badge>
  );
};

export default StatusBadge;
